// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Isv6","importantInfo":"styles_importantInfo__3dQic"};